import template from './reimburse-and-pay.html';

import { ComponentBase } from "../Common/componentBase";
import { RegisterDefaultComponent } from "../Common/componentsHelpers";


export class ReimburseAndPayViewModel extends ComponentBase {
    constructor(params) {
        super(params);

        this.claimsPortalPath = $.cdh.global.reimburseAndPay;
    }


}

RegisterDefaultComponent('reimburse-and-pay', template, ReimburseAndPayViewModel);